import { render, staticRenderFns } from "./SortCategory.vue?vue&type=template&id=239642df&scoped=true&"
import script from "./SortCategory.vue?vue&type=script&lang=js&"
export * from "./SortCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239642df",
  null
  
)

export default component.exports